import { useState, useEffect } from "react";
import { useLocation, Navigate, useNavigate, Route, Routes } from "react-router-dom";
import ThemeProvider from "./contexts/themeProvider";
import AuthService from "./services/auth.service";

import Logout from "./components/Logout";
import Work from "./components/Work";
import Login from "./components/Login";
function App() {
  const [currentUser, setCurrentUser] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const getUser = async () => {
    try {
      // Valide la session côté serveur (le cookie httpOnly est envoyé auto)
      const user = await AuthService.checkSession()
      if (!user) {
        return navigate('/login')
      }
      setCurrentUser(user)
      if (location.pathname !== '/Logout') {
        navigate('/Dashboard')
      }
    } finally {
      setIsLoading(true)
    }
  }

  useEffect(() => {
    getUser()
  }, []);
 
  return (
    <ThemeProvider>
      {isLoading && <div>
        <nav className="navbar navbar-expand navbar-dark bg-dark">
          <Routes>
            <Route path="/Logout" element={<Logout setCurrentUser={setCurrentUser} />} />
            {currentUser &&  <Route path="/*" element={<Work />} />}
            {!currentUser && <Route path="/Login" element={<Login />} />}
            //<Route path="/*" element={currentUser ? <Navigate to="/Work" /> : <Navigate to="/Login" />} />
          </Routes>
        </nav>
      </div>}
    </ThemeProvider>
  );
}

export default App;
